import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ClinicOverview } from '../../../common/model/dto/clinic';
import { OrderBy } from '../../../common/types';
import { useClinicListColumns } from '../../../hooks/use-clinic-list-columns';
import { useListNavigationState } from '../../../hooks/use-list-navigation-state';
import OvRecordList from './OvRecordList';

interface OvClinicListProps {
  clinics: ClinicOverview[];
  orderBy: string;
  orderDir: string;
  onSort: (order: OrderBy) => void;
}

const OvClinicList: FC<OvClinicListProps> = ({
  clinics,
  orderBy,
  orderDir,
  onSort,
}) => {
  const { t } = useTranslation();
  const getNavigationState = useListNavigationState();
  const columns = useClinicListColumns(getNavigationState);

  return (
    <OvRecordList
      label={t('app.subPages.menu.clinics')}
      records={clinics}
      columns={columns}
      getKey={(clinic) => clinic.id}
      getDetailsPath={(clinic) => `/clinics/${clinic.id}`}
      getNavigationState={getNavigationState}
      orderBy={orderBy}
      orderDir={orderDir}
      onSort={onSort}
    />
  );
};

export default OvClinicList;
